module.exports = __webpack_public_path__ + "img/11.055c5bc7.png";